import React from 'react';

const ICOIframe = () => {
    return <><iframe height={'700px'} width={'800px'} src={'https://instantcashoffers.net/embedded?publisher_id=417&subid=iframe&cake=caketest'} style={{border:0}}></iframe></>
}

export default ICOIframe;
